<template>
    <div class="row">
        <div class="col" v-for="item in items">
            <div class="card" style="width: 18rem;">
                <img class="card-img-top" :src="item.image" :alt="item.title">
                <div class="card-body">
                    <h5 class="card-title">{{ item.title }}</h5>
                    <a :href="item.url" class="btn btn-block btn-outline-primary">[ OPEN ]</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "RelatedNews",
        props: {
            genres: {
                type: Array,
                required: false,
            },
            locations: {
                type: Array,
                required: false,
            },
            categories: {
                type: Array,
                required: false,
            },
            amount: {
                type: Number,
                required: false,
            },
        },
        data() {
            return {
                items: []
            }
        },
        created() {
            let url = '/api/components/related-news?' + (new URLSearchParams(this.$props)).toString()

            console.log(url)

            return axios.get(url)
                .then(response => this.items = response.data)
        }
    }
</script>
